import { Grid, Typography } from "@mui/material";
import Certificate from "./Certificate";
import React from "react";

function AccomplishmentSkill({ skill, onDownload }) {
    if (!skill) return null;

    return (
        <Grid container spacing={4}>
            {!!skill.description && (
                <Grid item xs={12}>
                    <Typography variant="body2">
                        <strong>Description</strong> {skill.description}
                    </Typography>
                </Grid>
            )}
            <Grid item xs={12} sm={12} md={6}>
                <Typography variant="body2">
                    <strong>Skill</strong> {skill.name}
                </Typography>
                <Typography variant="body2">
                    <strong>Code</strong> {skill.code}
                </Typography>

                {!!skill.issuer && (
                    <Typography variant="body2">
                        <strong>Issuer</strong> {skill.issuer}
                    </Typography>
                )}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
                <Typography variant="body2">
                    <strong>Type</strong> {skill.type}
                </Typography>
                <Typography variant="body2">
                    <strong>Level</strong> {skill.level}
                </Typography>
                <Typography variant="body2">
                    <strong>Scope</strong> {skill.scope}
                </Typography>

                {!!skill.certificate && (
                    <Certificate
                        name={skill.certificate.name}
                        onDownload={onDownload}
                    />
                )}
            </Grid>
        </Grid>
    );
}

export default AccomplishmentSkill;
